import React from 'react';
import {connect} from 'react-redux';
import {Panel} from 'primereact/components/panel/Panel';
import {ProgressBar} from "primereact/progressbar";
import {getMailShotResults, RES_PDF_SHOT} from "../../../actions/mailShots";
import {setState, SM_PDF_MAIL_SHOT_RESULTS} from "../../../actions/stateManagement";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Button} from "primereact/button";
import {
    ICON_PATIENT_FEMALE,
    ICON_PATIENT_MALE,
    TB_MAILSHOT_RECIPIENTS,
    TB_PATIENT_DETAILS
} from "../PatientDetails/Constants";
import {ContextMenu} from "primereact/components/contextmenu/ContextMenu";
import {MailShotBase} from "../Utilities/MailShotBase";
import {CONST_FEMALE} from "../../PatientDynamicItems/OnChangeUtils";

class ConnectedPDFMailShotResults extends MailShotBase {

    constructor(props) {
        super(props);

        if (props.currentState) {
            this.state = props.currentState.data;
        } else {

            this.state = {

                stateManagementId: props.shotResultsDataId,

                dataTableSelectValue: {empty: true},

                first: 0,
                rows: 10,
                firstResults: 0,
                rowsResults: 10,
            }
        }
        this.editor = null;
    }

    componentDidMount() {

        if (!this.props.shotResultsLoaded) {
            this.props.getMailShotResults({pmsId: this.props.pmsShotId});
        }
    }

    componentDidUpdate(prevProps, prevState, ss) {

        if (this.props.message !== prevProps.message) {

            switch (this.props.message.type) {
                default:
                    break;
            }
        }
    }

    onSelectionChanged = (event) => {

        this.setState({dataTableSelectValue: event.value}, () => {
            this.props.setState(this.state.stateManagementId, this.state, this.props.parentId);
        });
    }

    buildItems() {

        if (this.state.dataTableSelectValue === null) return;

        const genderIcon = this.state.dataTableSelectValue.gender === CONST_FEMALE ? ICON_PATIENT_FEMALE : ICON_PATIENT_MALE;

        return [
            {
                label: TB_PATIENT_DETAILS.text, icon: genderIcon, command: (e) => {

                    this.onShowDetails(this.state.dataTableSelectValue, null);
                }
            },
        ]
    }

    render() {

        if (!this.props.shotResultsLoaded) {
            return <ProgressBar mode="indeterminate" style={{height: '6px'}}/>;
        }

        const items = this.buildItems();

        const submissionsHeader = <div className='panel-header-centered-content'><label id='panel-header'>Patient
            Submissions{` (${this.props.shotResults.length})`}</label>
        </div>;

        const patientName = this.state.dataTableSelectValue.empty ? '-' : `${this.state.dataTableSelectValue.firstName} ${this.state.dataTableSelectValue.lastName} : ${this.usedOnTemplate(this.state.dataTableSelectValue)}`;

        const resultsHeader = <div className='panel-header-centered-content'><label id='panel-header'>Submission Data ({patientName})</label></div>;

        return (
            <div className="p-grid" style={{fontSize: 'small'}}>

                {this.showDialogs()}

                <div className="p-col-4" style={{paddingTop: '5px'}}>
                    <Panel header={submissionsHeader} style={{marginTop: '5px'}}>
                        <div className="p-grid p-fluid p-col-12" style={{fontSize: 'small'}}>

                            <ContextMenu style={{width: 300}} model={items} ref={el => this.cm = el}/>

                            <DataTable value={this.props.shotResults}
                                       className='p-datatable-gridlines'
                                       style={{fontSize: 'small'}}
                                       selectionMode="single"
                                       paginator={true}
                                       rows={this.state.rows}
                                       rowsPerPageOptions={[10, 50, 200]}
                                       onPage={(e) => this.onPageFlex(e, 'first', 'rows')}
                                       first={this.state.first}
                                       selection={this.state.dataTableSelectValue}
                                       onSelectionChange={(e) => this.onSelectionChanged(e)}
                                       contextMenuSelection={this.state.dataTableSelectValue}
                                       onContextMenuSelectionChange={(e) => this.onSelectionChanged(e)}
                                       onContextMenu={e => {
                                           this.cm.show(e.originalEvent)
                                       }}
                            >
                                <Column body={(row) => this.fullnameTemplate(row)} header='Patient'
                                        style={{width: '60%'}}/>
                                <Column body={(row) => this.usedOnTemplate(row)} header='Submiited On'
                                        style={{width: '40%'}}/>
                            </DataTable>
                        </div>
                    </Panel>
                </div>

                <div className="p-col-8" style={{paddingTop: '5px'}}>
                    <Panel header={resultsHeader} style={{marginTop: '5px'}}>
                        <div className="p-grid p-fluid p-col-12" style={{fontSize: 'small'}}>

                            <DataTable value={this.state.dataTableSelectValue.data}
                                       className='p-datatable-gridlines'
                                       style={{fontSize: 'small'}}
                                       selectionMode="single"
                                       paginator={true}
                                       rows={this.state.rowsResults}
                                       rowsPerPageOptions={[10, 50, 200]}
                                       onPage={(e) => this.onPageFlex(e, 'firstResults', 'rowsResults')}
                                       first={this.state.firstResults}
                            >
                                <Column field="key"
                                        header="Key" style={{width: '20%'}}/>
                                <Column field="tag"
                                        header="Tag" style={{width: '20%'}}/>
                                <Column field="value"
                                        header="Value" style={{width: '60%'}}/>
                            </DataTable>
                        </div>
                    </Panel>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {

    const shotResultsLoadedId = `${SM_PDF_MAIL_SHOT_RESULTS.loaded}_${ownProps.pmsShotId}`;
    const shotResultsDataId = `${SM_PDF_MAIL_SHOT_RESULTS.id}_${ownProps.pmsShotId}`;

    const shotResultsLoaded = Boolean(state.mailShot[shotResultsLoadedId]) ? state.mailShot[shotResultsLoadedId] : false;
    const shotResults = shotResultsLoaded ? state.mailShot[shotResultsDataId] : null;

    return {

        message: state.stateManagement.message,

        loginIdentity: state.login.user,

        shotResultsDataId,
        shotResultsLoaded,
        shotResults,

        onPCButtonClick: state.login.onPCButtonClick,

        currentState: state.stateManagement[shotResultsDataId],
    };
};

const mapDispatchToProps = dispatch => {

    return {

        getMailShotResults: (params) => dispatch(getMailShotResults(RES_PDF_SHOT.GET_RESULTS_BY_ID, params)),

        setState: (id, data, parent) => dispatch(setState(id, data, parent)),
    };
};

const PDFMailShotResults = connect(mapStateToProps, mapDispatchToProps)(ConnectedPDFMailShotResults);

export default PDFMailShotResults;
